import { memo } from 'react';
import { ToolbarExportIcons } from '../../../../../../icons/icons';
import { ExportButtonProps } from './index';
import { Box, ButtonBase, Typography } from '@mui/material';

export const ExportButton = memo<ExportButtonProps>(({ handleExport }) => (
  <ButtonBase
    onClick={handleExport}
    title="Export data as CSV file"
    aria-label="Export data as CSV file"
    sx={{
      minHeight: 32,
      display: 'flex',
      alignItems: 'center',
      gap: 0.75,
      whiteSpace: 'nowrap',
      borderRadius: '8px',
      border: '1px solid',
      borderColor: '#d1fae5',
      bgcolor: '#ecfdf5',
      px: 1.25,
      fontSize: '12px',
      fontWeight: 600,
      color: '#059669',
      transition: 'all 0.3s',
      '&:hover': { bgcolor: 'rgba(209,250,229,0.8)' },
      '&:active': { bgcolor: 'rgba(167,243,208,0.5)' },
    }}
  >
    <Box
      sx={{
        display: 'flex',
        transition: 'transform 0.2s',
        '.MuiButtonBase-root:hover &': { transform: 'translateY(-1px)' },
      }}
    >
      <ToolbarExportIcons className="w-3.5 h-3.5" />
    </Box>
    <Typography
      component="span"
      sx={{ fontSize: 'inherit', fontWeight: 'inherit', display: { xs: 'none', sm: 'block' } }}
    >
      Export CSV
    </Typography>
    <Typography
      component="span"
      sx={{ fontSize: 'inherit', fontWeight: 'inherit', display: { xs: 'block', sm: 'none' } }}
    >
      Export
    </Typography>
  </ButtonBase>
));

ExportButton.displayName = 'ExportButton';
